import { render } from "./proposal-page.vue?vue&type=template&id=7c19d7ff&scoped=true"
import script from "./proposal-page.vue?vue&type=script&lang=js"
export * from "./proposal-page.vue?vue&type=script&lang=js"

import "./proposal-page.vue?vue&type=style&index=0&id=7c19d7ff&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c19d7ff"]])

export default __exports__